import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DxAutocompleteComponent } from 'devextreme-angular';
import { Subject, Subscription } from 'rxjs';
import { ClientService } from 'src/app/services/client.service';
import { Client } from '../../model/client.model';
import { ClientEditorComponent } from '../client-editor/client-editor.component';

@UntilDestroy({ checkProperties: true})
@Component({
  selector: 'app-client-finder',
  templateUrl: './client-finder.component.html',
  styleUrls: ['./client-finder.component.css']
})
export class ClientFinderComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() showPanel = true;

  @Input() showNewClientButton = true;
  results: any = [];
  searchTerm$ = new Subject<string>();
  sub: Subscription;
  showLoadingIndicator = false;
  @ViewChild(DxAutocompleteComponent) AutoCompleteBox: DxAutocompleteComponent;
  @ViewChild(ClientEditorComponent) clientEditor: ClientEditorComponent;
  @Output() onClientSelected: EventEmitter<number> = new EventEmitter<number>();

  // https://alligator.io/angular/real-time-search-angular-rxjs/
  constructor(private clientService: ClientService, private changeDetectorRef: ChangeDetectorRef) {
    this.onKeyUp = this.onKeyUp.bind(this);
    this.btnNewClient = this.btnNewClient.bind(this);
    this.CloseDlg = this.CloseDlg.bind(this);

    this.sub = this.clientService.search(this.searchTerm$)
      .subscribe(results => {
        this.showLoadingIndicator = false;

        this.results = results;
        if (this.results.length < 1) {
          this.results.push({ FirstName: 'No results found. Please enter a more specific search term', LastName: '' });
        }

        this.AutoCompleteBox.opened = (this.results.length > 0) && (this.AutoCompleteBox.text?.length >= 3);
        this.changeDetectorRef.detectChanges();
      });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.sub = null;
    this.searchTerm$?.unsubscribe();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.AutoCompleteBox.instance.instance().focus();
    }, 200);
  }

  onKeyUp(e) {
    if (e.event.code == 'ArrowDown' || e.event.code == 'ArrowUp' || e.event.code == 'ArrowLeft' || e.event.code == 'ArrowRight') {
      this.showLoadingIndicator = false;
      return;
    }
    if (this.AutoCompleteBox.text.length >= 3) {
      this.showLoadingIndicator = true;
      this.searchTerm$.next(this.AutoCompleteBox.text);
    }
    else
      this.showLoadingIndicator = false;
  }

  onItemClick(e) {
    if (e.itemData) {
      this.onClientSelected.emit(e.itemData.Id);
    }
  }

  Reset() {
    this.showLoadingIndicator = false;
    this.results = [];
    this.AutoCompleteBox?.instance?.reset();
    this.searchTerm$.next('xxxxxxxxxxYYYYYYYzzzzzzz');
  }

  btnNewClient(e) {
    this.clientEditor.showClientById(-1);
  }

  CloseDlg(c: Client) {
    if (c) {
      this.onClientSelected.emit(c.Id);
    }
  }
}
